import React, { useState, useContext } from "react";
import { BrowserRouter as Router, Link } from "react-router-dom";
import classes from "./Benefits.module.scss";
import { Text, LanguageContext } from "../../containers/Language";
import InputMask from "react-input-mask";

import { isMobile } from "react-device-detect";
import { useForm } from "react-hook-form";
import { Modal } from "../Modal/Modal";

import "tooltipster/dist/css/tooltipster.bundle.css";
import Tooltipster from "react-tooltipster/dist/Tooltipster";
import { requests } from "../../services/requests";

const Benefits = ({ valueFromNav, count }) => {
  const { dictionary, userLanguage } = useContext(LanguageContext);

  const [disabled, setDisabled] = useState(false);
  const [error, setError] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();
  const onSubmit = (form) => consultationMessage(form);
  const [success, setSuccess] = useState(false);

  const consultationMessage = async (data) => {
    setDisabled(true);
    requests
      .consultion(data)
      .then((res) => {
        if (res.status === 200) {
          setSuccess(true);
          setDisabled(false);
          setError(false);
        }
      })
      .catch(() => {
        setSuccess(false);
        setDisabled(false);
        setError(true);
      });
    reset({});
  };

  React.useEffect(() => {
    setSuccess(valueFromNav);
    reset({});
  }, [count, reset, valueFromNav]);

  return (
    <div className={classes.benefits}>
      <div className="container">
        <h3 className={`text-center ${classes.benefits_title}`}>
          <Text tid="BEN_TITLE" />
        </h3>

        <p className={`text-center ${classes.benefits_subtitle}`}>
          <Text tid="BEN_SUBTITLE" />
        </p>

        <ul className={classes.benlist}>
          <li>
            <i className="far fa-check"></i>
            <Tooltipster
              trigger={isMobile ? "click" : "hover"}
              animation="grow"
              theme="tooltipster-default"
              content={
                <p className={`${classes.tooltip} mb-0`}>
                  <Text tid="BEN_TOOLTIP_1_TEXT" />
                </p>
              }
              side="bottom"
            >
              <Text tid="BEN_TOOLTIP_1" />
            </Tooltipster>
          </li>

          <li>
            <i className="far fa-check"></i>
            <Tooltipster
              trigger={isMobile ? "click" : "hover"}
              animation="grow"
              className="tooltip-shadow"
              theme="tooltipster-default"
              content={
                <p className={`${classes.tooltip} mb-0`}>
                  <Text tid="BEN_TOOLTIP_2_TEXT" />
                </p>
              }
              side="bottom"
            >
              <Text tid="BEN_TOOLTIP_2" />
            </Tooltipster>
          </li>

          <li>
            <i className="far fa-check"></i>
            <Tooltipster
              trigger={isMobile ? "click" : "hover"}
              animation="grow"
              theme="tooltipster-default"
              content={
                <p className={`${classes.tooltip} mb-0`}>
                  <Text tid="BEN_TOOLTIP_3_TEXT" />
                </p>
              }
              side="bottom"
            >
              <Text tid="BEN_TOOLTIP_3" />
            </Tooltipster>
          </li>

          <li>
            <i className="far fa-check"></i>
            <Tooltipster
              trigger={isMobile ? "click" : "hover"}
              animation="grow"
              theme="tooltipster-default"
              content={
                <p className={`${classes.tooltip} mb-0`}>
                  <Text tid="BEN_TOOLTIP_4_TEXT" />
                </p>
              }
              side="bottom"
            >
              <Text tid="BEN_TOOLTIP_4" />
            </Tooltipster>
          </li>
        </ul>

        <div className={`row ${classes.ben_items}`}>
          <div className={`col ${classes.ben_item}`}>
            <section>
              <div className={classes.background}></div>

              <div className={classes.ben_iteminfo}>
                <div className={classes.item_title}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="37"
                    height="39"
                    viewBox="0 0 37 39"
                  >
                    <g fill="none" fillRule="evenodd">
                      <g fillRule="nonzero">
                        <g>
                          <g>
                            <g>
                              <path
                                fill="#393286"
                                d="M36.029 20.783c-.06.576-.556 1.013-1.152.953-.575-.06-1.012-.556-.953-1.151l2.105.179v.02zm-2.065-1.33h2.124V20.724l-2.104-.179V19.274l-.02.18zM18.044 5.161V3.037l.913.02.913.06.894.099.893.139.873.178.854.219.834.258.813.298.794.317.775.357.754.397.734.417.715.457.675.476.655.516.635.536.596.576.575.596.536.615.497.635.476.675.437.695.397.714.357.735.318.754.278.774.238.775.198.794.16.813.118.834.08.834.02.853h-2.125l-.02-.734-.059-.715-.1-.714-.138-.695-.179-.695-.218-.675-.238-.655-.278-.655-.318-.635-.357-.615-.377-.596-.417-.576-.437-.555-.476-.536-.497-.516-.516-.497-.555-.476-.576-.457-.596-.436-.615-.397-.655-.378-.675-.337-.695-.318-.714-.297-.735-.258-.734-.219-.755-.198-.774-.16-.794-.118-.794-.1-.814-.059-.833-.02h.06zm0 0c-.576 0-1.052-.476-1.052-1.052 0-.576.476-1.052 1.052-1.052v2.124-.02zM2.124 19.453H0l.02-.853.08-.834.118-.834.16-.813.198-.794.238-.775.278-.774.317-.754.358-.735.397-.714.436-.695.477-.675.496-.635.536-.615.576-.596.595-.576.635-.536.656-.516.674-.476.715-.457.735-.417.754-.397.774-.357.794-.317.814-.298.834-.258.853-.219.874-.178.893-.14.893-.098.913-.06.913-.02v2.124l-.833.02-.814.06-.794.099-.794.119-.774.159-.755.198-.734.219-.735.258-.714.297-.695.318-.675.337-.655.378-.615.397-.596.436-.576.457-.555.476-.516.497-.497.516-.476.536-.437.555-.417.576-.377.596-.357.615-.318.635-.278.655-.238.655-.218.675-.179.695-.139.695-.1.714-.059.715-.02.734h.06zm.04 1.033l-2.104.159V19.374h2.124V20.466l-.02.02zm0 0c.04.575-.397 1.091-.973 1.131-.576.04-1.092-.397-1.131-.972l2.104-.16zM16.992 16c0-.576.476-1.053 1.052-1.053.576 0 1.052.477 1.052 1.052h-2.124.02zm0 17.627V15.999h2.124v17.628h-2.124zm2.124 0c0 .575-.476 1.052-1.052 1.052-.576 0-1.052-.477-1.052-1.052h2.124-.02z"
                                transform="translate(-125 -1368) translate(95 1095) translate(0 245) translate(30 28)"
                              />
                              <path
                                fill="#5CA595"
                                d="M24.893 20.843c0 .576-.477 1.052-1.053 1.052-.575 0-1.052-.476-1.052-1.052h2.124-.02zm-6.849-3.791v-2.124h.338l.337.02.337.04.338.039.318.06.317.079.318.08.298.098.297.12.298.119.278.139.278.139.258.158.258.179.238.179.238.198.239.199.218.218.198.218.199.239.179.238.178.258.16.258.138.258.139.278.12.278.098.278.08.297.06.298.039.298.02.318v.317h-2.124v-.178l-.02-.18-.02-.178-.04-.178-.04-.18-.059-.178-.06-.178-.079-.16-.099-.158-.1-.159-.099-.159-.119-.158-.119-.16-.139-.138-.139-.14-.158-.138-.16-.139-.178-.12-.179-.118-.178-.12-.199-.099-.198-.099-.199-.08-.218-.079-.218-.08-.219-.059-.238-.06-.238-.039-.238-.04-.239-.02-.258-.02h-.258l.02.02zm0 0c-.576 0-1.052-.477-1.052-1.053 0-.575.476-1.052 1.052-1.052v2.124-.02zm-4.724 3.791h-2.124v-.318l.02-.317.04-.298.059-.298.08-.297.098-.278.12-.278.138-.278.14-.258.158-.258.179-.258.179-.239.198-.238.199-.218.218-.218.238-.199.238-.198.239-.18.258-.178.258-.159.278-.139.277-.139.298-.119.298-.119.298-.099.317-.08.318-.079.318-.06.337-.039.337-.04.338-.02h.337v2.124h-.258l-.258.02-.238.02-.238.04-.238.04-.239.06-.218.059-.218.079-.219.08-.198.079-.199.1-.198.098-.179.12-.178.119-.18.119-.158.139-.159.139-.139.139-.139.138-.119.16-.119.158-.1.159-.098.159-.1.158-.079.16-.06.178-.06.179-.039.178-.04.179-.02.179-.02.178v.179l.02-.02zm0 0c0 .576-.477 1.052-1.052 1.052-.576 0-1.052-.476-1.052-1.052h2.124-.02z"
                                transform="translate(-125 -1368) translate(95 1095) translate(0 245) translate(30 28)"
                              />
                              <path
                                fill="#393286"
                                d="M36.029 20.664c.02.576-.437 1.072-1.013 1.092-.575.02-1.072-.437-1.092-1.012l2.124-.08h-.02zm-6.63-3.612v-2.124h.337l.318.02.317.04.318.039.317.06.298.079.298.08.298.098.278.12.278.119.277.139.259.139.258.158.238.16.238.178.238.178.219.199.218.198.198.219.199.218.179.238.158.239.16.258.138.258.12.258.118.278.1.278.079.277.06.298.06.298.039.298.02.298-2.124.079-.02-.179-.02-.178-.04-.179-.04-.179-.059-.178-.06-.179-.079-.159-.08-.159-.079-.158-.099-.16-.1-.158-.118-.159-.12-.139-.138-.139-.14-.139-.138-.139-.16-.119-.158-.119-.179-.119-.178-.1-.179-.098-.198-.1-.199-.08-.198-.079-.199-.06-.218-.059-.219-.06-.218-.039-.218-.04-.239-.02-.238-.02h-.238l.06.02zm0 0c-.576 0-1.052-.477-1.052-1.053 0-.575.476-1.052 1.052-1.052v2.124-.02zm-4.526 3.791h-2.124v-.318l.02-.297.04-.298.059-.298.08-.298.098-.278.12-.277.119-.278.139-.258.158-.258.16-.259.178-.238.198-.238.199-.218.218-.219.219-.198.238-.199.238-.178.258-.179.258-.159.278-.159.278-.139.278-.119.298-.119.297-.099.298-.1.318-.079.317-.06.318-.059.318-.04.337-.02h.337v2.125h-.238l-.238.02-.238.02-.238.04-.219.039-.218.06-.218.059-.219.08-.198.079-.199.08-.198.098-.179.1-.179.119-.178.119-.16.119-.158.12-.139.138-.139.139-.139.139-.119.159-.119.159-.1.158-.098.16-.08.158-.08.159-.059.178-.06.179-.04.179-.039.178-.02.179-.02.179v.178l-.02.04zm0 0c0 .576-.477 1.052-1.052 1.052-.576 0-1.052-.476-1.052-1.052h2.124-.02zM13.32 20.843c0 .576-.477 1.052-1.052 1.052-.576 0-1.052-.476-1.052-1.052h2.124-.02zm-6.65-3.791v-2.124h.337l.338.02.317.04.318.059.318.06.317.079.298.099.298.1.297.118.278.12.278.138.278.16.258.158.258.179.238.178.239.199.218.198.218.219.199.218.198.238.179.238.159.239.159.258.139.258.119.278.119.277.099.278.08.298.059.298.04.298.02.297v.318h-2.124v-.179l-.02-.178-.02-.179-.04-.179-.04-.178-.06-.179-.059-.179-.08-.158-.078-.16-.1-.158-.099-.159-.12-.159-.118-.139-.14-.138-.138-.14-.14-.138-.158-.14-.159-.118-.178-.12-.179-.119-.179-.099-.198-.1-.199-.079-.198-.079-.218-.08-.219-.059-.218-.06-.219-.04-.238-.039-.238-.02-.238-.02H6.69l-.02-.02zm0 0c-.576 0-1.052-.477-1.052-1.053 0-.575.476-1.052 1.052-1.052v2.124-.02zm-4.526 3.573l-2.104-.14.02-.297.04-.298.059-.278.08-.278.098-.278.1-.277.119-.258.139-.259.139-.258.159-.238.158-.238.179-.218.198-.219.199-.198.218-.199.219-.198.238-.179.238-.179.238-.158.258-.16.258-.138.278-.12.278-.118.278-.1.298-.099.298-.08.297-.079.298-.06.318-.039.317-.04.318-.02h.318v2.125H6.45l-.238.02-.218.02-.219.039-.218.04-.218.06-.219.059-.198.06-.199.079-.198.08-.179.098-.178.1-.18.099-.158.119-.159.12-.158.118-.14.12-.138.138-.14.14-.118.138-.12.14-.099.158-.099.159-.1.159-.079.158-.08.16-.059.158-.06.159-.039.178-.04.18-.02.178-.02.178-.02-.04zm0 0c-.04.575-.536 1.032-1.132.992-.575-.04-1.032-.536-.992-1.131l2.104.139h.02z"
                                transform="translate(-125 -1368) translate(95 1095) translate(0 245) translate(30 28)"
                              />
                              <path
                                fill="#5CA595"
                                d="M13.32 20.783c.04.576-.397 1.092-.993 1.132-.576.04-1.092-.397-1.131-.993l2.104-.139h.02zm4.406-17.686l.656 2.024-.477.199-.456.238-.417.298-.397.357-.377.397-.358.457-.337.496-.298.556-.278.595-.258.616-.238.655-.199.675-.178.694-.16.695-.138.715-.12.714-.098.715-.08.695-.06.675-.059.655-.04.635-.02.615-.02.576-.02.536v2.244l-2.103.138V18.58l.02-.556.02-.595.04-.635.039-.675.06-.695.079-.715.08-.734.098-.755.12-.754.158-.774.179-.774.198-.755.239-.754.258-.734.297-.715.338-.695.377-.675.417-.635.457-.595.516-.556.555-.496.616-.437.675-.357.734-.278-.04-.14zm0 0c.556-.179 1.152.119 1.33.675.18.555-.119 1.15-.674 1.33l-.656-2.025v.02z"
                                transform="translate(-125 -1368) translate(95 1095) translate(0 245) translate(30 28)"
                              />
                              <path
                                fill="#5CA595"
                                d="M22.769 20.783l2.104.14c-.04.575-.536 1.032-1.132.992-.575-.04-1.032-.536-.992-1.132h.02zM18.362 3.097l.734.278.675.357.615.437.556.496.516.556.457.595.417.635.377.675.337.695.298.715.258.734.238.755.199.754.179.774.158.774.12.754.099.755.08.734.079.715.06.695.039.675.04.635.02.595.02.556V20.824l-2.105-.14V18.441l-.02-.536-.02-.576-.02-.615-.04-.635-.059-.655-.06-.675-.079-.695-.099-.714-.119-.715-.139-.715-.159-.694-.178-.695-.199-.675-.238-.655-.258-.616-.278-.595-.298-.556-.337-.496-.358-.457-.377-.397-.397-.357-.417-.298-.456-.238-.477-.199.655-2.024-.04.139zm0 0l-.655 2.024c-.556-.178-.854-.774-.675-1.33.178-.555.774-.853 1.33-.674v-.02z"
                                transform="translate(-125 -1368) translate(95 1095) translate(0 245) translate(30 28)"
                              />
                              <path
                                fill="#5CA595"
                                d="M19.096 4.11c0 .575-.476 1.051-1.052 1.051-.576 0-1.052-.476-1.052-1.052h2.124-.02zm0-3.038v3.037h-2.124V1.072h2.124zm-2.124 0c0-.576.477-1.052 1.052-1.052.576 0 1.052.476 1.052 1.052h-2.124.02z"
                                transform="translate(-125 -1368) translate(95 1095) translate(0 245) translate(30 28)"
                              />
                              <path
                                fill="#393286"
                                d="M9.588 32.674c.139-.576.695-.933 1.27-.794.576.139.933.695.794 1.27l-2.064-.476zm2.005.953H9.469V32.673l2.064.477v.338l.06.139zm2.7 2.382v2.124h-.239l-.238-.02-.238-.02-.238-.04-.219-.04-.218-.059-.219-.06-.218-.079-.218-.08-.199-.098-.198-.1-.199-.119-.178-.119-.18-.139-.178-.139-.159-.139-.158-.159-.16-.158-.138-.16-.139-.178-.12-.179-.118-.198-.12-.199-.099-.198-.099-.199-.08-.218-.059-.218-.06-.219-.04-.218-.039-.238-.02-.238v-.239h2.124v.239l.02.119.02.119.02.119.04.12.04.098.039.1.06.099.06.1.059.098.06.1.079.099.08.1.078.078.08.08.1.08.098.079.1.08.099.059.119.06.12.059.118.06.12.059.118.04.12.04.138.039.14.02.138.02.14.02.138.02h.14l-.02-.06zm0 0c.575 0 1.051.476 1.051 1.052 0 .576-.476 1.052-1.052 1.052v-2.124.02zm2.699-2.382h2.124v.238l-.02.238-.04.238-.04.219-.059.218-.06.218-.079.219-.099.198-.1.199-.118.198-.12.199-.119.178-.138.18-.14.178-.158.159-.16.158-.158.14-.179.138-.178.14-.179.118-.198.12-.199.099-.198.099-.219.08-.218.079-.218.06-.219.059-.218.04-.238.04-.239.02-.238.019h-.238v-2.124h.139l.139-.02.139-.02.139-.02.139-.02.139-.04.119-.039.119-.04.12-.06.118-.059.12-.06.118-.059.1-.06.099-.079.1-.08.098-.079.08-.079.08-.08.079-.099.079-.099.06-.1.06-.098.059-.1.06-.099.039-.1.04-.098.04-.12.02-.119.019-.119.02-.119v-.238l-.02.04zm0 0c0-.576.476-1.052 1.052-1.052.576 0 1.052.476 1.052 1.052h-2.124.02z"
                                transform="translate(-125 -1368) translate(95 1095) translate(0 245) translate(30 28)"
                              />
                              <path
                                fill="#393286"
                                d="M11.632 34.063c-.04.576-.536 1.033-1.111 1.013-.576-.04-1.032-.536-1.013-1.112l2.124.12v-.02zm.16-2.957l-.16 2.957-2.124-.119.16-2.957 2.123.119zm-2.125-.12c.04-.575.536-1.032 1.112-1.012.575.04 1.032.536 1.012 1.112l-2.124-.12v.02z"
                                transform="translate(-125 -1368) translate(95 1095) translate(0 245) translate(30 28)"
                              />
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </svg>

                  <span>
                    <Text tid="BEN_ITEM1_TITLE" />
                  </span>
                </div>

                <p>
                  <Text tid="BEN_ITEM1_TEXT" />
                </p>
              </div>
            </section>
          </div>

          <div className={`col ${classes.ben_item}`}>
            <section>
              <div className={classes.background}></div>

              <div className={classes.ben_iteminfo}>
                <div className={classes.item_title}>
                  <svg
                    className={classes.reliability}
                    xmlns="http://www.w3.org/2000/svg"
                    width="39"
                    height="39"
                    viewBox="0 0 39 39"
                  >
                    <g
                      fill="none"
                      fillRule="evenodd"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <g strokeWidth="2">
                        <g>
                          <g>
                            <g>
                              <path
                                stroke="#393286"
                                d="M12.856 5.421L18.115 0.162 25.415 7.462 18.115 14.762 15.724 12.371"
                                transform="translate(-477 -1371) translate(95 1095) translate(0 245) translate(383 32)"
                              />
                              <path
                                stroke="#5CA595"
                                d="M5.403 12.874L5.403 5.421 15.724 5.421 15.724 15.751 12.389 15.751"
                                transform="translate(-477 -1371) translate(95 1095) translate(0 245) translate(383 32)"
                              />
                              <path
                                stroke="#393286"
                                d="M5.403 23.366L0.162 18.115 7.462 10.815 14.762 18.115 12.424 20.453"
                                transform="translate(-477 -1371) translate(95 1095) translate(0 245) translate(383 32)"
                              />
                              <path
                                stroke="#5CA595"
                                d="M12.82 30.782L5.403 30.782 5.403 20.453 15.724 20.453 15.724 23.806"
                                transform="translate(-477 -1371) translate(95 1095) translate(0 245) translate(383 32)"
                              />
                              <path
                                stroke="#393286"
                                d="M23.357 30.782L18.088 36.051 10.788 28.751 18.088 21.451 20.48 23.842"
                                transform="translate(-477 -1371) translate(95 1095) translate(0 245) translate(383 32)"
                              />
                              <path
                                stroke="#5CA595"
                                d="M30.8 23.33L30.8 30.782 20.48 30.782 20.48 20.453 23.815 20.453"
                                transform="translate(-477 -1371) translate(95 1095) translate(0 245) translate(383 32)"
                              />
                              <path
                                stroke="#393286"
                                d="M30.8 12.847L36.051 18.088 28.751 25.388 21.451 18.088 23.788 15.751"
                                transform="translate(-477 -1371) translate(95 1095) translate(0 245) translate(383 32)"
                              />
                              <path
                                stroke="#5CA595"
                                d="M23.384 5.421L30.8 5.421 30.8 15.751 20.48 15.751 20.48 12.397"
                                transform="translate(-477 -1371) translate(95 1095) translate(0 245) translate(383 32)"
                              />
                              <path
                                stroke="#393286"
                                d="M16.38 1.897L18.115 0.162 25.415 7.462 18.79 14.088 19.338 13.539"
                                transform="translate(-477 -1371) translate(95 1095) translate(0 245) translate(383 32)"
                              />
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </svg>

                  <span>
                    <Text tid="BEN_ITEM2_TITLE" />
                  </span>
                </div>

                <p
                  dangerouslySetInnerHTML={{
                    __html: dictionary.BEN_ITEM2_TEXT,
                  }}
                ></p>
                <ul className={classes.lawList}>
                  <li>
                    <span>1.</span>
                    {userLanguage === "az" ? (
                      <>
                        <p>
                          <Text tid="BEN_ITEM2_TEXT_1" />
                          <br />
                          <Router>
                            <Link
                              to={{
                                pathname:
                                  "http://www.e-qanun.az/framework/3813",
                              }}
                              target="_blank"
                            >
                              <Text tid="BEN_ITEM2_TEXT_1_LINK" />
                            </Link>
                          </Router>
                        </p>
                      </>
                    ) : userLanguage === "ru" ? (
                      <>
                        <p>
                          <Router>
                            <Link
                              to={{
                                pathname:
                                  "http://www.e-qanun.az/framework/3813",
                              }}
                              target="_blank"
                            >
                              <Text tid="BEN_ITEM2_TEXT_1_LINK" />
                            </Link>
                          </Router>{" "}
                          &nbsp;
                          <Text tid="BEN_ITEM2_TEXT_1" />
                        </p>
                      </>
                    ) : null}
                  </li>
                  <li>
                    <span>2.</span>
                    {userLanguage === "az" ? (
                      <>
                        <p>
                          <Text tid="BEN_ITEM2_TEXT_2" /> &nbsp;
                          <Router>
                            <Link
                              to={{
                                pathname:
                                  "https://www.taxes.gov.az/az/page/ar-vergi-mecellesi",
                              }}
                              target="_blank"
                            >
                              <Text tid="BEN_ITEM2_TEXT_2_LINK" />
                            </Link>
                          </Router>
                        </p>
                      </>
                    ) : userLanguage === "ru" ? (
                      <>
                        <p>
                          <Router>
                            <Link
                              to={{
                                pathname:
                                  "https://www.taxes.gov.az/az/page/ar-vergi-mecellesi",
                              }}
                              target="_blank"
                            >
                              <Text tid="BEN_ITEM2_TEXT_2_LINK" />
                            </Link>
                          </Router>{" "}
                          &nbsp;
                          <Text tid="BEN_ITEM2_TEXT_2" />
                        </p>
                      </>
                    ) : null}
                  </li>
                </ul>
              </div>
            </section>
          </div>

          <div className={`col ${classes.ben_item}`}>
            <section>
              <div className={classes.background}></div>

              <div className={classes.ben_iteminfo}>
                <div className={classes.item_title}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="39"
                    viewBox="0 0 32 39"
                  >
                    <g fill="none" fillRule="evenodd">
                      <g fillRule="nonzero">
                        <g>
                          <g>
                            <g>
                              <g fill="#5CA595">
                                <path
                                  d="M11.886 10.443c0 .593-.461 1.054-1.054 1.054s-1.054-.461-1.054-1.054h2.108zm-5.83-6.686V1.65h.33l.33.033.329.065.329.1.296.098.297.132.296.164.264.165.263.198.264.197.23.23.23.231.231.264.198.263.197.297.198.296.198.296.164.33.165.33.165.328.131.363.132.362.132.362.099.363.098.395.1.395.065.395.066.395.033.428.033.429.033.428v.428H9.844v-.362l-.033-.363-.033-.362-.033-.362-.033-.33-.066-.329-.065-.33-.066-.329-.1-.296-.098-.296-.099-.297-.099-.263-.131-.264-.132-.263-.132-.23-.131-.231-.132-.23-.132-.198-.165-.198L8 4.712l-.165-.164-.165-.132-.164-.132-.165-.131-.165-.1-.164-.098-.165-.066-.165-.066-.164-.033-.165-.033-.165-.033h-.164l.033.033zm0 0c-.592 0-1.053-.46-1.053-1.054 0-.592.46-1.053 1.054-1.053v2.107zm-3.72 6.686H.226v-.428l.033-.428.033-.429.033-.428.066-.395.066-.395.099-.395.099-.396.098-.362.132-.362.132-.362.132-.363.164-.329.165-.33.165-.329.197-.296.198-.296.197-.297.198-.263.23-.264.231-.23.23-.23.264-.198.264-.198.263-.165.296-.164.297-.132.296-.099.33-.099.329-.066.33-.032h.329V3.79h-.165l-.165.033-.164.033-.165.033-.165.066-.164.066-.165.099-.165.098-.164.132-.165.132-.165.132-.164.164-.165.165-.165.198-.132.197-.131.23-.132.231-.132.23-.131.264-.132.264-.099.263-.099.297-.099.296-.098.296-.066.33-.066.329-.066.33-.033.329-.033.362-.033.362-.033.362v.363l.033-.033zm0 0c0 .593-.462 1.054-1.055 1.054-.592 0-1.054-.461-1.054-1.054h2.108z"
                                  transform="translate(-831 -1368) translate(95 1095) translate(0 245) translate(736 28) translate(9.587 15.673)"
                                />
                                <path
                                  d="M4.97 1.123C4.97.53 5.43.069 6.024.069c.593 0 1.054.46 1.054 1.054H4.97zm0 9.32v-9.32h2.108v9.32H4.97zm2.108 0c0 .593-.461 1.054-1.054 1.054s-1.054-.461-1.054-1.054h2.108z"
                                  transform="translate(-831 -1368) translate(95 1095) translate(0 245) translate(736 28) translate(9.587 15.673)"
                                />
                              </g>
                              <path
                                fill="#393286"
                                d="M18.509 8.069c0 .592-.462 1.054-1.054 1.054-.593 0-1.054-.462-1.054-1.054h2.108zm0-3.228V8.07H16.4V4.84l1.054-1.054 1.054 1.054zm-2.108 0c0-.593.46-1.054 1.054-1.054.592 0 1.054.461 1.054 1.054H16.4zm-2.635-1.054h3.689v2.108h-3.689l-1.054-1.054 1.054-1.054zm0 2.108c-.593 0-1.054-.461-1.054-1.054s.461-1.054 1.054-1.054v2.108zm-1.054 2.14V4.809h2.108v3.228h-2.108zm2.108 0c0 .594-.461 1.055-1.054 1.055s-1.054-.461-1.054-1.054h2.108z"
                                transform="translate(-831 -1368) translate(95 1095) translate(0 245) translate(736 28)"
                              />
                              <path
                                fill="#393286"
                                d="M20.155 2.108h-9.122V0h9.122l1.054 1.054-1.054 1.054zm0-2.108c.593 0 1.054.461 1.054 1.054s-.461 1.054-1.054 1.054V0zm-1.054 4.874V1.087h2.108v3.787l-1.054 1.054-1.054-1.054zm2.108 0c0 .593-.461 1.054-1.054 1.054s-1.054-.461-1.054-1.054h2.108zM11.033 3.82h9.122v2.108h-9.122L9.979 4.874l1.054-1.054zm0 2.108c-.593 0-1.054-.461-1.054-1.054s.46-1.054 1.054-1.054v2.108zm1.054-4.874V4.84H9.979V1.054L11.033 0l1.054 1.054zm-2.108 0C9.979.46 10.439 0 11.033 0c.592 0 1.054.461 1.054 1.054H9.979z"
                                transform="translate(-831 -1368) translate(95 1095) translate(0 245) translate(736 28)"
                              />
                              <path
                                fill="#5CA595"
                                d="M25.622 11.988c-.395.428-1.054.46-1.482.066-.428-.396-.46-1.054-.066-1.482l1.548 1.449v-.033zm3.326-3.623l-3.326 3.623-1.548-1.45 3.327-3.622 1.482-.066.065 1.482v.033zm-1.547-1.449c.395-.428 1.053-.461 1.482-.066.428.395.46 1.054.065 1.482l-1.547-1.449v.033zm2.535 3.787l-2.47-2.305 1.45-1.548 2.47 2.305.065 1.482-1.482.066h-.033zm1.45-1.548c.428.396.46 1.054.065 1.482-.395.429-1.054.462-1.482.066l1.45-1.548h-.034zm-4.973 3.82l3.458-3.754 1.547 1.45-3.458 3.754-1.547-1.45zm1.547 1.45c-.395.428-1.053.46-1.482.066-.428-.396-.46-1.054-.065-1.482l1.547 1.449v-.033z"
                                transform="translate(-831 -1368) translate(95 1095) translate(0 245) translate(736 28)"
                              />
                              <path
                                fill="#393286"
                                d="M2.108 22.526H0l.033-.79.066-.79.099-.79.131-.758.165-.758.198-.757.23-.725.264-.724.296-.692.33-.659.362-.658.395-.626.428-.626.461-.592.494-.56.527-.527.527-.527.56-.494.593-.461.625-.428.626-.396.659-.362.658-.33.692-.329.724-.263.725-.23.757-.198.758-.165.757-.132.79-.098.791-.066.79-.033V9.09l-.691.033-.692.065-.658.1-.659.13-.659.166-.625.197-.626.198-.626.23-.593.264-.592.296-.56.33-.56.362-.527.362-.494.395-.494.428-.461.461-.461.462-.428.494-.396.494-.362.526-.362.56-.33.56-.296.593-.263.593-.23.626-.198.625-.198.626-.165.659-.131.658-.1.659-.065.692-.033.691.132-.099zM15.61 36.03v2.108l-.79-.033-.79-.066-.79-.099-.758-.132-.758-.164-.757-.198-.725-.23-.724-.264-.692-.33-.659-.328-.658-.363-.626-.395-.626-.428-.592-.461-.56-.494-.527-.527-.527-.527-.494-.56-.461-.593-.428-.625-.396-.626-.362-.659-.33-.658-.296-.692-.263-.725-.23-.724-.198-.758-.165-.757-.132-.758-.098-.79-.066-.79-.033-.79h2.108l.032.69.066.692.1.66.13.658.166.658.197.626.198.626.23.626.264.592.296.593.33.56.362.56.362.527.395.494.428.494.461.461.461.461.494.428.494.395.527.363.56.362.56.33.593.296.593.263.625.23.626.198.626.198.659.165.658.131.659.1.692.065.691.033-.132-.099zm13.503-13.503h2.108l-.033.79-.066.791-.099.79-.132.758-.164.758-.198.757-.23.725-.264.724-.33.692-.328.658-.363.659-.395.626-.428.625-.461.593-.494.56-.527.527-.527.527-.56.494-.593.461-.625.428-.626.395-.659.363-.658.329-.692.33-.725.263-.724.23-.758.198-.757.165-.758.131-.79.1-.79.065-.79.033v-2.108l.69-.033.692-.066.66-.098.658-.132.658-.165.626-.197.626-.198.626-.23.592-.264.593-.296.56-.33.56-.362.527-.362.494-.395.494-.429.461-.46.461-.462.428-.494.395-.494.363-.527.362-.56.33-.56.296-.592.263-.593.23-.626.198-.625.198-.626.165-.659.131-.659.1-.658.065-.692.033-.691-.099.098zM15.61 9.024V6.916l.79.033.791.066.79.099.758.131.758.165.757.198.725.23.724.264.692.329.658.33.659.362.626.395.625.428.593.46.56.495.527.527.527.527.494.56.461.592.428.626.395.626.363.659.329.658.33.692.263.724.23.725.198.757.165.758.131.757.1.79.065.791.033.79h-2.108l-.033-.691-.066-.692-.098-.658-.132-.659-.165-.659-.197-.625-.198-.626-.23-.626-.264-.593-.296-.592-.33-.56-.362-.56-.362-.527-.395-.494-.429-.494-.46-.461-.462-.461-.494-.428-.494-.396-.527-.362-.56-.362-.56-.33-.592-.296-.593-.263-.626-.23-.625-.198-.626-.198-.659-.165-.659-.131-.658-.1-.692-.065-.691-.033.098.099z"
                                transform="translate(-831 -1368) translate(95 1095) translate(0 245) translate(736 28)"
                              />
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </svg>

                  <span>
                    <Text tid="BEN_ITEM3_TITLE" />
                  </span>
                </div>

                <p
                  dangerouslySetInnerHTML={{
                    __html: dictionary.BEN_ITEM3_TEXT,
                  }}
                ></p>
              </div>
            </section>
          </div>

          <div className={`col ${classes.ben_item}`}>
            <section>
              <div className={classes.background}></div>

              <div className={classes.ben_iteminfo}>
                <div className={classes.item_title}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="39"
                    height="39"
                    viewBox="0 0 39 39"
                  >
                    <g fill="none" fillRule="evenodd">
                      <g fillRule="nonzero">
                        <g>
                          <g>
                            <g>
                              <path
                                fill="#393286"
                                d="M36.712 22.848l-23.47-7.95.676-2.004 23.47 7.95.054 1.983-.73.021zm.675-2.004c.556.186.85.785.664 1.34-.185.555-.784.85-1.34.664l.676-2.004zm-8.538 3.159l7.808-3.137.795 1.96-7.808 3.137-1.154-.24.359-1.72zm.795 1.96c-.545.218-1.154-.044-1.372-.588-.218-.545.043-1.154.588-1.372l.795 1.96h-.011zm5.717 6.817l-6.871-7.067 1.513-1.482 6.872 7.068.011 1.47-1.525.011zm1.514-1.48c.403.413.403 1.088-.021 1.491-.414.403-1.09.403-1.493-.021l1.514-1.482v.011zm-5.554 4.236l4.03-4.226 1.535 1.46-4.03 4.225-1.513.022-.022-1.481zm1.536 1.46c-.403.424-1.078.435-1.492.032-.425-.403-.436-1.078-.033-1.492l1.536 1.46h-.011zm-7.09-8.506l7.068 7.024-1.492 1.503-7.068-7.025-.24-1.143 1.732-.36zm-1.492 1.502c-.414-.413-.414-1.078 0-1.492.414-.413 1.078-.413 1.492 0l-1.492 1.503v-.01zm-3.333 6.567l3.093-7.71 1.96.784-3.092 7.71-1.982-.032.01-.752h.011zm1.96.785c-.217.544-.838.805-1.371.588-.545-.218-.806-.839-.589-1.373l1.96.785zm-8.33-23.829l8.342 23.077-1.993.719-8.342-23.077 1.34-1.361.653.642zm-1.993.719c-.196-.545.087-1.154.631-1.35.545-.197 1.155.087 1.35.631l-1.992.719h.01z"
                                transform="translate(-1183 -1368) translate(95 1095) translate(0 245) translate(1088 28)"
                              />
                              <path
                                fill="#5CA595"
                                d="M9.235 7.94c.403.424.392 1.088-.022 1.491-.424.403-1.089.392-1.492-.022l1.525-1.47h-.01zM3.42 1.927l5.815 6.011L7.71 9.41 1.895 3.398l1.525-1.47zm-1.525 1.47c-.403-.425-.392-1.09.022-1.492.424-.403 1.089-.392 1.492.022l-1.525 1.47h.01zM3.43 18.557c-.457.37-1.121.305-1.491-.152-.37-.457-.305-1.122.152-1.492l1.34 1.644zm5.718-4.65l-5.717 4.65-1.34-1.644 5.717-4.65 1.34 1.644zm-1.34-1.644c.458-.37 1.122-.305 1.492.152.37.458.305 1.122-.152 1.492l-1.34-1.644zM17 1.862c.349-.468 1.013-.566 1.481-.218.468.349.567 1.013.218 1.482L17 1.862zm-4.41 5.903L17 1.862 18.7 3.126l-4.41 5.902-1.7-1.263zm1.698 1.263c-.348.469-1.012.567-1.48.218-.469-.348-.567-1.013-.219-1.481l1.7 1.263zM8.93 1.209C8.854.632 9.246.098 9.834.01c.577-.076 1.111.316 1.198.904l-2.09.294H8.93zm.871 6.12l-.87-6.12 2.09-.294.871 6.12-2.09.294zm2.091-.294c.077.577-.315 1.111-.903 1.198-.578.076-1.111-.316-1.198-.904l2.09-.294h.011zM.882 11.13c-.577-.098-.97-.642-.871-1.22.098-.577.642-.969 1.22-.87l-.349 2.09zm6.012 1.002L.882 11.13l.349-2.09 6.011 1.001-.348 2.091zm.348-2.09c.577.097.97.642.871 1.219-.098.577-.642.969-1.22.871l.35-2.09zM15.976 11.446c-.588-.011-1.045-.49-1.034-1.078.01-.588.49-1.046 1.078-1.035l-.044 2.113zm5.01.098l-5.01-.098.044-2.113 5.01.098-.044 2.113zm.044-2.113c.588.011 1.045.49 1.034 1.078-.01.588-.49 1.046-1.078 1.035l.044-2.113zM9.137 16.14c-.076-.577.327-1.111.915-1.187.577-.077 1.11.326 1.187.904l-2.102.283zm.664 5.01l-.664-5.01 2.102-.283.664 5.01-2.102.282zm2.102-.284c.077.577-.326 1.111-.914 1.187-.578.077-1.111-.326-1.188-.904l2.102-.283z"
                                transform="translate(-1183 -1368) translate(95 1095) translate(0 245) translate(1088 28)"
                              />
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </svg>

                  <span>
                    <Text tid="BEN_ITEM4_TITLE" />
                  </span>
                </div>

                <p
                  dangerouslySetInnerHTML={{
                    __html: dictionary.BEN_ITEM4_TEXT,
                  }}
                ></p>
              </div>

              <Router>
                <Link to={{ pathname: "https://mylife.az/" }} target="_blank">
                  <button className="btn btn-secondary btn-lg">
                    Şəxsi kabinetə keçin
                  </button>
                </Link>
              </Router>
            </section>
          </div>
        </div>

        <p className={classes.consultation}>
          {dictionary.HAVE_QUES}
          <span
            onClick={() => {
              setSuccess(false);
              reset({});
            }}
            data-bs-toggle="modal"
            data-bs-target="#consultation"
          >
            {dictionary.CONS_REQUEST}
          </span>

          <Modal
            success={success}
            error={error}
            id="consultation"
            title={dictionary.CONS_MODAL_TITLE}
          >
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="modal-body">
                <div className={`row ${classes.modalForm}`}>
                  <div className="col-lg-6">
                    <div className="form-group">
                      <label>{dictionary.NAME_SURNAME}</label>
                      <input
                        autoComplete="off"
                        {...register("Name", { required: true })}
                        disabled={disabled}
                        type="text"
                        className={`form-control rounded ${
                          errors.Name && `is-invalid`
                        }`}
                        placeholder={dictionary.ENTER_NAME}
                      />
                      {errors.Name && (
                        <div className="error-notification">
                          {dictionary.ERROR_REQUIRED}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="form-group">
                      <label>{dictionary.MOB_NUM}</label>
                      <InputMask
                        disabled={disabled}
                        autoComplete="off"
                        {...register("MobileNumber", { required: true })}
                        className={`form-control rounded ${
                          errors.MobileNumber && `is-invalid`
                        }`}
                        mask="+(\9\94)-99-999-99-99"
                        maskChar={null}
                        placeholder={dictionary.ENTER_NUM}
                      />
                      {errors.MobileNumber && (
                        <div className="error-notification">
                          {dictionary.ERROR_REQUIRED}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="form-group">
                      <label>{dictionary.COMP_NAME}</label>
                      <input
                        autoComplete="off"
                        {...register("CompanyName", { required: false })}
                        disabled={disabled}
                        type="text"
                        className={`form-control rounded ${
                          errors.CompanyName && `is-invalid`
                        }`}
                        placeholder={dictionary.ENTER_COMP_NAME}
                      />
                      {errors.CompanyName && (
                        <div className="error-notification">
                          {dictionary.ERROR_REQUIRED}
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <p className={classes.modalInfo}>
                  {dictionary.CONS_MODAL_INFO}
                </p>
              </div>
              <div className="modal-footer">
                <button
                  disabled={disabled}
                  type="submit"
                  className="btn btn-primary btn-lg rounded btn-shadow"
                >
                  {disabled ? (
                    <>
                      <div class="spinner-border"></div> {dictionary.WAIT}
                    </>
                  ) : (
                    dictionary.CALL_ME
                  )}{" "}
                </button>
              </div>
            </form>
          </Modal>

          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="13"
            height="12"
            viewBox="0 0 13 12"
          >
            <g fill="none" fillRule="evenodd">
              <g fill="#5959F5" fillRule="nonzero">
                <g>
                  <g>
                    <g>
                      <path
                        d="M432.75 15.125c.177 0 .333-.063.469-.188l4.625-4.453c.146-.135.219-.3.219-.492 0-.193-.073-.357-.22-.492l-4.593-4.438c-.146-.125-.313-.187-.5-.187-.188 0-.346.07-.477.21-.13.142-.195.306-.195.493 0 .188.073.35.219.484l3.375 3.25h-8.969c-.198 0-.367.073-.508.22-.14.145-.205.317-.195.515.01.177.083.328.219.453.135.125.291.188.469.188h8.953l-3.375 3.25c-.136.135-.206.296-.211.484-.006.187.06.349.195.484.135.146.302.219.5.219z"
                        transform="translate(-1006 -1724) translate(95 1095) translate(0 245) translate(485 380)"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </p>
      </div>
    </div>
  );
};

export default Benefits;
